import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Tours from "./pages/Tours";
import TailorMade from "./pages/TailorMade";
import VideoReviews from "./pages/VideoReviews";
import Contact from "./pages/Contact";
import AuthenticIndianExperiences from "./pages/Authentic_Indian_Experiences";
import Hotel_List from "./pages/Hotel_List";
import Car_Details from "./pages/Car_Details";
import GoldenTriangleShortTour from "./pages/GoldenTriangleShortTour";
import GoldenTriangleStandardTour from "./pages/GoldenTriangleStandardTour";
import GoldenTriangleOberoiHotels from "./pages/GoldenTriangleOberoiHotels";
import GoldenTriangleTigerTour from "./pages/GoldenTriangleTigerTour";
import BestLuxuryPrivateIndiaTour from "./pages/BestLuxuryPrivateIndiaTour";
import SinglePost from "./pages/SinglePost";
import Blog from "./pages/Blog";
import Term_Condition from "./pages/Term_Condition";
import Tour_extension from "./pages/Tour_extension";
import SEO from "./components/SEO";
import Faq from "./pages/Faq";
import UkAdsHome from "./pages/UkAdsHome";

function App() {
  const location = useLocation();
  const hideFooter = location.pathname.replace(/\/$/, "") === "/tailor-made-private-tour";

  return (
    <>
      <SEO />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/tours" element={<Tours />} />
        <Route path="/luxury-golden-triangle-enquiry" element={<TailorMade />} />
        <Route path="/video-reviews" element={<VideoReviews />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/authentic-indian-experiences" element={<AuthenticIndianExperiences />} />
        <Route path="/5-star-luxury-hotels" element={<Hotel_List />} />
        <Route path="/car-details" element={<Car_Details />} />
        <Route path="/golden-triangle-short-tour" element={<GoldenTriangleShortTour />} />
        <Route path="/golden-triangle-standard-tour" element={<GoldenTriangleStandardTour />} />  
        <Route path="/golden-triangle-oberoi-hotels" element={<GoldenTriangleOberoiHotels />} />  
        <Route path="/golden-triangle-tiger-tour" element={<GoldenTriangleTigerTour />} />
        <Route path="/best-luxury-private-india-tour" element={<BestLuxuryPrivateIndiaTour />} />
        <Route path="/tailor-made-private-tour" element={<UkAdsHome />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/:slug" element={<SinglePost />} />
        <Route path="/terms-conditions" element={<Term_Condition />} />
        <Route path="/golden-triangle-tour-extensions" element={<Tour_extension />} />
        <Route path="/faq" element={<Faq />} />
      </Routes>
      {!hideFooter && <Footer />}
    </>
  );
}

export default App;
